

import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom"; // Added useHistory
import AddClient from "../components/Invoice/AddClient";
import AddSupplier from "../components/Suppliers/AddSupplier";
import AddStaff from "../components/Staff/AddStaff";
import DSRDialog from "../components/Invoices/DSRDialog";
import usePermissions from "../utils/permissions";
import * as api from "../api/index";
import { useShift } from "../Context/ShiftContext";
import { useSnackbar } from "react-simple-snackbar";

import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Button, // Added Button
  Avatar, // Added Avatar
  Popper, // Added Popper
  Grow, // Added Grow
  Paper, // Added Paper
  ClickAwayListener, // Added ClickAwayListener
  MenuList, // Added MenuList
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@material-ui/core";
import { AppContext } from "../Context/AppContext";
import { withStyles } from "@material-ui/core/styles";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  PermIdentity as PermIdentityIcon,
  GroupAdd as GroupAddIcon,
  Add as AddIcon,
  Assignment,
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
  PersonAdd as PersonAddIcon,
} from "@material-ui/icons";
import { useDispatch } from "react-redux"; // Added useDispatch

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const CartHeader = ({ classes, theme, handleDrawerClose, invoices }) => {
  const [anchorEl, setAnchorEl] = useState(null); // For the Add Options menu
  const [openProfile, setOpenProfile] = useState(false); // For the profile dropdown
  const user = JSON.parse(localStorage.getItem("profile"));
  const [openClient, setOpenClient] = useState(false);
  const [openSupplier, setOpenSupplier] = useState(false);
  const [confirmShiftStart, setConfirmShiftStart] = useState(false);
  const [confirmShiftEnd, setConfirmShiftEnd] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [lastShiftsByEmployee, setLastShiftsByEmployee] = useState({});
  const [selectedEmployeeForShift, setSelectedEmployeeForShift] = useState("");
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const snackbarOptions = { position: "top-center", style: { zIndex: 99999 } };
  const [openSnackbar] = useSnackbar(snackbarOptions);
  const {
    myActiveShift,
    fetchMyActiveShift,
    startShift,
    endShift,
    shiftLoading,
  } = useShift();

  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    canReadPage,
    isAdmin,
    // canDownloadReports,
  } = usePermissions();

  // State for permissions and loading
  const [canDownloadReports, setcanDownloadReports] = useState(false);
  const [isAdminn, setIsAdminn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch my active shift when on POS
  useEffect(() => {
    fetchMyActiveShift();
  }, [fetchMyActiveShift]);

  // Fetch permissions from database
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found");
        setIsAdminn(profile?.result?.userType?.includes("admin") || false);

        const { data } = await api.getUserPermissions();
        setcanDownloadReports(data.canDownloadPdfReports || false);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching permissions:", error.message);
        setcanDownloadReports(false); // Fallback to no permission
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);

  const [openStaff, setOpenStaff] = useState(false);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  const dispatch = useDispatch(); // For logout action
  const history = useHistory(); // For navigation
  const anchorRef = React.useRef(null); // Ref for profile button

  // Handlers for Add Options menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Handlers for Profile dropdown
  const handleProfileToggle = () => {
    setOpenProfile((prevOpen) => !prevOpen);
  };
  const handleProfileClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenProfile(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenProfile(false);
    }
  };
  const openLink = (link) => {
    history.push(`/${link}`);
    setOpenProfile(false);
  };
  const logout = () => {
    dispatch({ type: "LOGOUT" });
    history.push("/");
    window.location.reload();

  };

  // Handlers for DSR dialog
  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };
  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };
  const handleCloseDSR = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };

  const handleOpenShiftStartDialog = () => {
    setConfirmShiftStart(true);
    setSelectedEmployeeForShift("");
    setLoadingEmployees(true);
    Promise.all([api.fetchEmployees(), api.getLastShiftByEmployee()])
      .then(([empRes, shiftRes]) => {
        const employees = Array.isArray(empRes.data) ? empRes.data : [];
        setEmployeesList(employees);
        setLastShiftsByEmployee(shiftRes.data || {});
      })
      .catch(() => {
        setEmployeesList([]);
        setLastShiftsByEmployee({});
      })
      .finally(() => setLoadingEmployees(false));
  };

  const formatLastShiftForEmployee = (startTime, endTime) => {
    if (!startTime || !endTime) return "No previous shift";
    const d = new Date(startTime);
    const dateStr = d.toLocaleDateString(undefined, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    const timeOpt = { hour: "2-digit", minute: "2-digit", hour12: true };
    const start = new Date(startTime).toLocaleTimeString(undefined, timeOpt);
    const end = new Date(endTime).toLocaleTimeString(undefined, timeOpt);
    return `${dateStr} ${start} – ${end}`;
  };

  const lastShiftEntries = Object.entries(lastShiftsByEmployee);
  const mostRecentShiftCart = lastShiftEntries.length
    ? lastShiftEntries.reduce((best, [empId, sh]) => {
        const end = sh?.endTime ? new Date(sh.endTime) : null;
        if (!end) return best;
        if (!best) return { empId, ...sh };
        return end > new Date(best.endTime) ? { empId, ...sh } : best;
      }, null)
    : null;
  const mostRecentEmpNameCart = mostRecentShiftCart
    ? employeesList.find((e) => e._id === mostRecentShiftCart.empId)?.name || "Unknown"
    : null;

  const handleConfirmShiftStart = async () => {
    if (!selectedEmployeeForShift) {
      openSnackbar("Please select an employee");
      return;
    }
    const employee = employeesList.find((e) => e._id === selectedEmployeeForShift);
    if (!employee) {
      openSnackbar("Selected employee not found");
      return;
    }
    const result = await startShift(employee, openSnackbar);
    if (result) {
      setConfirmShiftStart(false);
      setSelectedEmployeeForShift("");
    }
  };

  const handleConfirmShiftEnd = async () => {
    const result = await endShift(openSnackbar);
    if (result) setConfirmShiftEnd(false);
  };

  // Ensure focus returns to button after closing profile menu
  const prevOpen = React.useRef(openProfile);
  React.useEffect(() => {
    if (prevOpen.current === true && openProfile === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openProfile;
  }, [openProfile]);

  return (
    <>
      <AddClient setOpen={setOpenClient} open={openClient} />
      <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
      <AddStaff setOpen={setOpenStaff} open={openStaff} />
      <div className={classes.drawerHeader}>
        <Tooltip title="Close Drawer" arrow>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Settings" arrow>
          <Link to="/settings" style={{ textDecoration: "none" }}>
            <IconButton aria-label="delete" disabled color="primary">
              <SettingsIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Link>
        </Tooltip>

        {isAdmin() && (
          <Tooltip title="Admin Dashboard" arrow>
            <a href="/admindashboard" style={{ textDecoration: "none" }}>
              <IconButton aria-label="delete" disabled color="primary">
                <GroupAddIcon style={{ fontWeight: "bold", color: "black" }} />
              </IconButton>
            </a>
          </Tooltip>
        )}
        <div style={{ display: "none" }}>
          <Tooltip title="Add Options" arrow>
            <IconButton
              aria-controls="customized-menu"
              aria-haspopup="true"
              variant="contained"
              onClick={handleClick}
            >
              <PermIdentityIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Tooltip>
          <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {(isAdmin() || canReadPage("Customer")) && (
              <StyledMenuItem
                disabled={
                  permissionsLoading || (!isAdmin() && !canCreatePage("Customer"))
                }
                style={{
                  cursor:
                    permissionsLoading ||
                    (!isAdmin() && !canCreatePage("Customer"))
                      ? "not-allowed"
                      : "pointer",
                }}
                onClick={() => setOpenClient(true)}
              >
                <ListItemIcon>
                  <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Customer" />
              </StyledMenuItem>
            )}
            <StyledMenuItem onClick={() => setOpenSupplier(true)}>
              <ListItemIcon>
                <AddIcon
                  fontSize="small"
                  style={{ fontWeight: "bold", color: "black" }}
                />
              </ListItemIcon>
              <ListItemText primary="Supplier" />
            </StyledMenuItem>
          </StyledMenu>
        </div>
        {/* <Tooltip title="Help" arrow>
          <Link to="/help" style={{ textDecoration: "none" }}>
            <IconButton aria-label="delete" disabled color="primary">@
              <HelpIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Link>
        </Tooltip> */}

        <Tooltip title="Add Employee" arrow>
          <Link to="/employees" style={{ textDecoration: "none" }}>
            <IconButton aria-label="Add Employee">
              <PersonAddIcon style={{ fontWeight: "bold", color: "black" }} />
            </IconButton>
          </Link>
        </Tooltip>

        <Tooltip title="Daily Sales Report" arrow>
          <IconButton
            aria-controls="customized-menu"
            disabled={loading || (!isAdminn && !canDownloadReports)}
            style={{
              cursor:
                loading || (!isAdminn && !canDownloadReports)
                  ? "not-allowed"
                  : "pointer",
            }}
            aria-haspopup="true"
            variant="contained"
            onClick={() => setOpenDSR(true)}
          >
            <Assignment style={{ fontWeight: "bold", color: "black" }} />
          </IconButton>
        </Tooltip>

        {!myActiveShift ? (
          <Tooltip title="Shift Start" arrow>
            <IconButton
              aria-label="Shift Start"
              onClick={handleOpenShiftStartDialog}
              disabled={shiftLoading}
            >
              <PlayArrowIcon style={{ fontWeight: "bold", color: "#2e7d32" }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Shift End" arrow>
            <IconButton
              aria-label="Shift End"
              onClick={() => setConfirmShiftEnd(true)}
              disabled={shiftLoading}
            >
              <StopIcon style={{ fontWeight: "bold", color: "#c62828" }} />
            </IconButton>
          </Tooltip>
        )}

        <Dialog
          open={confirmShiftStart}
          onClose={() => setConfirmShiftStart(false)}
          style={{ zIndex: 10000 }}
          PaperProps={{ style: { zIndex: 10000 } }}
        >
          <DialogTitle>Start Shift</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: 8 }}>
              Select employee to start shift.
            </DialogContentText>
            {mostRecentEmpNameCart && mostRecentShiftCart && (
              <div
                style={{
                  marginBottom: 16,
                  padding: "8px 12px",
                  borderRadius: 8,
                  backgroundColor: "#f5f5f5",
                  fontSize: "0.75rem",
                }}
              >
                <div style={{ fontWeight: 600, marginBottom: 2, color: "#333" }}>
                  Last shift
                </div>
                <div style={{ color: "#666" }}>
                  {mostRecentEmpNameCart} →{" "}
                  {formatLastShiftForEmployee(
                    mostRecentShiftCart.startTime,
                    mostRecentShiftCart.endTime
                  )}
                </div>
              </div>
            )}
            {loadingEmployees ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
                <CircularProgress size={32} />
              </div>
            ) : (
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="shift-employee-label">Employee</InputLabel>
                <Select
                  labelId="shift-employee-label"
                  value={selectedEmployeeForShift}
                  onChange={(e) => setSelectedEmployeeForShift(e.target.value)}
                  label="Employee"
                  renderValue={(id) => {
                    const emp = employeesList.find((e) => e._id === id);
                    return emp ? `${emp.name}${!emp.active ? " (Inactive)" : ""}` : "";
                  }}
                  MenuProps={{
                    style: { zIndex: 10001 },
                    PaperProps: {
                      style: { zIndex: 10001, maxHeight: 320 },
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {[...employeesList]
                    .sort((a, b) => {
                      const aEnd = lastShiftsByEmployee[a._id]?.endTime;
                      const bEnd = lastShiftsByEmployee[b._id]?.endTime;
                      if (!aEnd && !bEnd) return 0;
                      if (!aEnd) return 1;
                      if (!bEnd) return -1;
                      return new Date(bEnd) - new Date(aEnd);
                    })
                    .map((emp) => {
                      const last = lastShiftsByEmployee[emp._id];
                      const lastShiftStr = formatLastShiftForEmployee(
                        last?.startTime,
                        last?.endTime
                      );
                      return (
                        <MenuItem
                          key={emp._id}
                          value={emp._id}
                          disabled={!emp.active}
                        >
                          <div>
                            <div
                              style={{
                                fontWeight: 500,
                                color: !emp.active ? "#999" : "inherit",
                              }}
                            >
                              {emp.name}
                              {!emp.active && " (Inactive)"}
                            </div>
                            <div style={{ fontSize: "0.75rem", color: "#666", marginTop: 2 }}>
                              Last shift → {lastShiftStr}
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            )}
            {!loadingEmployees && employeesList.length === 0 && (
              <DialogContentText style={{ marginTop: 8, color: "textSecondary" }}>
                No employees. Add in Employee Master.
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmShiftStart(false)}>Cancel</Button>
            <Button
              onClick={handleConfirmShiftStart}
              color="primary"
              variant="contained"
              disabled={
                shiftLoading ||
                !selectedEmployeeForShift ||
                loadingEmployees ||
                !employeesList.find((e) => e._id === selectedEmployeeForShift)?.active
              }
            >
              {shiftLoading ? "Starting…" : "Start"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog 
          open={confirmShiftEnd} 
          onClose={() => setConfirmShiftEnd(false)}
          style={{ zIndex: 10000 }}
          PaperProps={{ style: { zIndex: 10000 } }}
        >
          <DialogTitle>End shift?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to end your shift? You will not be able to add items until you start a new shift.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmShiftEnd(false)}>Cancel</Button>
            <Button onClick={handleConfirmShiftEnd} color="primary" variant="contained" disabled={shiftLoading}>
              {shiftLoading ? "Ending…" : "End shift"}
            </Button>
          </DialogActions>
        </Dialog>

        <DSRDialog
          open={openDSR}
          onClose={handleCloseDSR}
          date={dateDSR}
          handleDateChange={handleDateChange}
          handleSubmit={handleSubmit}
          showPreview={showPreviewDSR}
          rows={invoices}
          user={user}
          classes={classes}
        />

        {/* Profile Icon Section (Copied from Header) */}
        <div style={{ marginLeft: "auto" }}>
          <Tooltip title="Profile" arrow>
            <Button
              ref={anchorRef}
              aria-controls={openProfile ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleProfileToggle}
            >
              <Avatar
                style={{
                  backgroundColor: "white",
                  color: "#ef7f1a",
                  border: "1px solid",
                }}
              >
                {user?.result?.name?.charAt(0)}
              </Avatar>
            </Button>
          </Tooltip>
          <Popper
            open={openProfile}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 9999 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper elevation={3}>
                  <ClickAwayListener onClickAway={handleProfileClose}>
                    <MenuList
                      autoFocusItem={openProfile}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={() => openLink("settings")}>
                        {(user?.result?.name).split(" ")[0]}
                      </MenuItem>
                      <MenuItem onClick={() => openLink("help")}>
                        {"Help".split(" ")[0]}
                      </MenuItem>
                      <MenuItem onClick={() => logout()}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    </>
  );
};

export default CartHeader;
